/* eslint-disable max-lines */
/* eslint-disable max-len */
import businessTypesOptions from '@/mixins/businessTypesOptions';
import cnaeSubgroupsOptions from '@/mixins/cnaeSubgroupsOptions';
import cnaGroupOptions from '@/mixins/cnaGroupOptions';
import countriesOptions from '@/mixins/countriesOptions';
import DatePickerMixin from '@/mixins/datepicker';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import Validations from '@/mixins/validations';


export default {

    /**
     * Nombre del componente
     */
    name       : 'RegistralesPjData',

    mixins: [
        countriesOptions,
        formatData,
        keyed,
        Validations,
        cnaGroupOptions,
        businessTypesOptions,
        cnaeSubgroupsOptions,
        DatePickerMixin
    ],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            collapsed: true,
            vissibilityCollapse1: true,
            registralsPjEdit: false,
            formatDataRules: () => ({
                'entity_type': [ 'entity_type', value => (value ? { key: value, name: this.$t(`businessTypes.${value}`) } : null) ],
                'key_cnae_group': [ 'cnae_group', value => (value ? { key: value, name: this.$t(`interveners.cnae_groups.${value}`) } : null) ],
                'key_cnae_subgroup': [ 'cnae_subgroup', value => (value ? { key: value, name: this.$t(`interveners.cnae_subgroups.${this.data.key_cnae_group}.${value}`) } : null) ]
            })
        };
    },
    props : {
        uuid : {
            type     : String,
            required : false
        },
        data : {
            type     : Object,
            required : false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        intervenerStatus: {
            type: String,
            required: false,
            default: ''
        }
    },
    methods: {

        /**
         * @param {Boolean} edit allow edit or not
         * @param {Event} e Evento del form
         */
        editRegistralPj(edit, e) {
            e.preventDefault();
            e.stopPropagation();
            this.registralsPjEdit = edit;
            if (edit) {
                if (!this.collapsed) {
                    this.$root.$emit('bv::toggle::collapse', 'collapse-1');
                }
            }
            if (!edit) {
                this.formatData();
                this.modifiedData = {};
            }
        },
        /**
         * Validate Registrales data
         * @return {Boolean} valid or not
         */
        validateData() {
            this.cleanErrors();

            const requiredProperties = [
                'entity_type'
            ];

            return Promise.resolve(true)
                .then(valid => this.validateRequired(requiredProperties, valid));
        },
        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            switch (field) {
                case 'key_cnae_group':
                    this.selectedGroup = val.key;
                    this.modifiedData['key_cnae_group'] = val.key;
                    this.modifiedData['key_cnae_subgroup'] = null;
                    delete this.formattedData.cnae_subgroup;
                    break;
                case 'entity_type':
                    this.modifiedData['entity_type'] = val.key;
                    break;
                default:
                    this.modifiedData[field] = (typeof val === 'object')
                        ? val.key
                        : val;
                    break;
            }
        },

        /**
         * @param {Event} e FormEvent
         */
        onSubmit(e) {
            e.preventDefault();

            this.fetchValidatedData()
                .then(vd => {
                    if (!vd) {
                        this.$toast.error('Error en datos de registrales', 'Revisa los campos marcados en rojo');
                        return;
                    }
                    Promise.all([
                        this.$intervenersService.updateIntervenerBusiness(this.uuid, this.modifiedData)
                    ])
                        .then(res => {
                            this.$emit('saved', res[0].data.intervener);
                            this.$root.$emit('refresh_intervener');
                            this.registralsPjEdit = false;
                            this.modifiedData = {};
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        })
                        .catch(err => {
                            this.$toast.error(err.name, err.message);
                            this.formatData();
                            this.registralsPjEdit = false;
                            this.modifiedData = {};
                        });
                });
        }
    },

    /**
     * @override
     */
    beforeMount() {

        if (this.creation) {
            this.registralsPjEdit = !this.existing;
        }

    }
};
